export function isWithin7Days(dateString: string | null): boolean {
  if (!dateString) return false;
  const created = new Date(dateString).getTime();
  if (Number.isNaN(created)) return false;
  const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
  return Date.now() - created <= sevenDaysMs;
}
